import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
// import { useStyletron } from "baseui";
import {
  StatefulDataTable,
  StringColumn,
  CustomColumn,
} from "baseui/data-table";
import { Button } from "baseui/button";
// import { ButtonGroup } from "baseui/button-group";
import { Checkbox } from "baseui/checkbox";
import { Modal, ModalBody, SIZE } from "baseui/modal";
import VehicleUpdateForm from "./vehicleUpdateForm";
// import Inspections from "../components/features/vehicles/inspections";

const IncomingTable = () => {
  const [loginLocationId, setLoginLocationId] = useState(null);
  const [locationLabel, setLocationLabel] = useState("");

  const retrieveLoginLocationId = async () => {
    const storedLocation = localStorage.getItem("location");
    if (storedLocation) {
      try {
        const parsedLocation = JSON.parse(storedLocation);
        if (parsedLocation[0] && parsedLocation[0].id) {
          setLoginLocationId(parsedLocation[0].id);
          setLocationLabel(parsedLocation[0].label);
        } else {
          console.warn("Location ID not found in stored location.");
        }
      } catch (error) {
        console.error("Error parsing location from localStorage:", error);
      }
    } else {
      console.warn("No location found in localStorage.");
    }
  };

  // const [css] = useStyletron();
  const [inventory, setInventory] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [locationInventory, setLocationInventory] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [customerRows, setCustomerRows] = useState([]);
  const [relevantSteps, setRelevantSteps] = useState([]);
  const [relevantWords, setRelevantWords] = useState([]);
  const user = useSelector((state) => state.user);
  const [selectedInspectionTypes, setSelectedInspectionTypes] = useState([]);
  const [stepsMap, setStepsMap] = useState([]);
  const userRole = user.role_id;
  const userLocations = user.location_id;
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state

  const [steps, setSteps] = useState([]); //step_name strings
  const [inspections, setInspections] = useState([]);
  const [repairsOnly, setRepairsOnly] = useState(false);

  //   const [inspectionObject, setInspectionObject] = useState({});
  const [stock, setStock] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  // const [fetchComplete, setFetchComplete] = useState(false);

  function formatDate(dateString) {
    //     console.log("dateString", dateString);
    if (!dateString) {
      return ""; // Return an empty string if dateString is undefined or null
    }

    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const time = `${hours}:${minutes}${ampm}`;
    return `${month}-${day}-${year}, ${time}`;
  }

  const filterVehicles = () => {
    // Only return vehicles that match the selected inspection types
    return vehicles.filter((vehicle) => {
      const stepId = vehicle.app_status || vehicle.cust_app_status;
      const stepName = stepsMap[stepId];
      // Check if the step name exists in the selected inspection types
      return selectedInspectionTypes.includes(stepName);
    });
  };

  const stepVehicleCounts = Object.entries(stepsMap).map(
    ([stepId, stepName]) => {
      const matchingVehicles = vehicles.filter(
        (vehicle) =>
          vehicle.app_status === Number(stepId) ||
          vehicle.cust_app_status === Number(stepId)
      );

      return {
        stepId: Number(stepId),
        stepName,
        count: matchingVehicles.length,
      };
    }
  );

  // console.log("stepVehicleCounts", stepVehicleCounts);
  //

  // console.log("stepsMap", stepsMap);
  const filteredVehicles = filterVehicles();

  // FETCH DATA
  const fetchSteps = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/steps`);
      setSteps(response.data.steps);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // console.log("steps", steps);
  const createStepsMap = (steps) => {
    return steps.reduce((map, step) => {
      map[step.id] = `${step.step_name}`;
      return map;
    }, {});
  };

  useEffect(() => {
    if (steps.length > 0) {
      setStepsMap(createStepsMap(steps));
    }
  }, [steps]);

  // console.log("stepsMap", stepsMap);

  const fetchInspections = async () => {
    //     console.log("fetchInspections was run");
    try {
      const response = await axios.get(`${apiUrl}/api/inspections`);

      // Check if the response contains data and is not null or empty
      if (response.data && response.data.length > 0) {
        setInspections(response.data);
      } else {
        setInspections([]); // Set inspections to an empty array if no data is returned
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setInspections([]); // Optionally set inspections to an empty array if an error occurs
    }
  };

  // Fetch Inventory FOR  <StatefulDataTable/>, NOT the <Inspections/> import (useRef fn 'handleFetchData')
  const fetchInventory = useCallback(async () => {
    //     console.log("fetchInventory was run");
    try {
      const response = await axios.get(`${apiUrl}/api/admin/vehicle/list`);
      setInventory(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/customers`);
      setCustomers(response.data.customers);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  useEffect(() => {
    let combinedInventory = [];

    if (userLocations.includes(1) && loginLocationId === 1) {
      const specifiedLocation = "S01_Holmes1"; // Define the location string to be used
      const relevantInspections = inspections
        .filter(
          (insp) =>
            insp.location === specifiedLocation && insp.custRepairId != null
        )
        .map((insp) => ({
          custRepairId: insp.custRepairId,
          inspectionDate: insp.inspection_date,
        }));
      const inspectionDateMap = Object.fromEntries(
        relevantInspections.map((insp) => [
          insp.custRepairId,
          insp.inspectionDate,
        ])
      );
      const relevantCustomers = customers
        .filter((cust) =>
          relevantInspections.some((insp) => insp.custRepairId === cust.id)
        )
        .map((cust) => ({
          ...cust,
          currentLocation: specifiedLocation, // Add currentLocation property
          inspectionDate: inspectionDateMap[cust.id] || null, // Add inspectionDate
        }));

      combinedInventory = [
        ...combinedInventory,
        ...inventory.filter((car) => car.location === specifiedLocation),
        ...relevantCustomers,
      ];
    }

    if (userLocations.includes(2) && loginLocationId === 2) {
      const specifiedLocation = "S09_Douglas1"; // Define the location string to be used
      const relevantInspections = inspections
        .filter(
          (insp) =>
            insp.location === specifiedLocation && insp.custRepairId != null
        )
        .map((insp) => ({
          custRepairId: insp.custRepairId,
          inspectionDate: insp.inspection_date,
        }));
      const inspectionDateMap = Object.fromEntries(
        relevantInspections.map((insp) => [
          insp.custRepairId,
          insp.inspectionDate,
        ])
      );
      const relevantCustomers = customers
        .filter((cust) =>
          relevantInspections.some((insp) => insp.custRepairId === cust.id)
        )
        .map((cust) => ({
          ...cust,
          currentLocation: specifiedLocation, // Add currentLocation property
          inspectionDate: inspectionDateMap[cust.id] || null, // Add inspectionDate
        }));

      combinedInventory = [
        ...combinedInventory,
        ...inventory.filter((car) => car.location === specifiedLocation),
        ...relevantCustomers,
      ];
    }

    if (userLocations.includes(3) && loginLocationId === 3) {
      const specifiedLocation = "S05_Montgomery1"; // Define the location string to be used
      const relevantInspections = inspections
        .filter(
          (insp) =>
            insp.location === specifiedLocation && insp.custRepairId != null
        )
        .map((insp) => ({
          custRepairId: insp.custRepairId,
          inspectionDate: insp.inspection_date,
        }));
      const inspectionDateMap = Object.fromEntries(
        relevantInspections.map((insp) => [
          insp.custRepairId,
          insp.inspectionDate,
        ])
      );
      const relevantCustomers = customers
        .filter((cust) =>
          relevantInspections.some((insp) => insp.custRepairId === cust.id)
        )
        .map((cust) => ({
          ...cust,
          currentLocation: specifiedLocation, // Add currentLocation property
          inspectionDate: inspectionDateMap[cust.id] || null, // Add inspectionDate
        }));

      combinedInventory = [
        ...combinedInventory,
        ...inventory.filter((car) => car.location === specifiedLocation),
        ...relevantCustomers,
      ];
    }

    if (userLocations.includes(4) && loginLocationId === 4) {
      const specifiedLocation = "S07_Bham1"; // Define the location string to be used
      const relevantInspections = inspections
        .filter(
          (insp) =>
            insp.location === specifiedLocation && insp.custRepairId != null
        )
        .map((insp) => ({
          custRepairId: insp.custRepairId,
          inspectionDate: insp.inspection_date,
        }));
      const inspectionDateMap = Object.fromEntries(
        relevantInspections.map((insp) => [
          insp.custRepairId,
          insp.inspectionDate,
        ])
      );
      const relevantCustomers = customers
        .filter((cust) =>
          relevantInspections.some((insp) => insp.custRepairId === cust.id)
        )
        .map((cust) => ({
          ...cust,
          currentLocation: specifiedLocation, // Add currentLocation property
          inspectionDate: inspectionDateMap[cust.id] || null, // Add inspectionDate
        }));

      combinedInventory = [
        ...combinedInventory,
        ...inventory.filter((car) => car.location === specifiedLocation),
        ...relevantCustomers,
      ];
    }

    // console.log("combinedInventory", combinedInventory);
    function normalizeInventory(combinedInventory) {
      // combining jobs from 'inventory' and 'customer' tables
      return combinedInventory.map((item) => {
        // Check if item is in alternate format
        if (item.StockNbr) {
          return {
            id: item.id,
            stock: item.StockNbr,
            vin: item.VIN,
            year: item.Year,
            make: item.Make,
            model: item.Model,
            color: item.Color,
            location: item.currentLocation, // From currentLocation
            status: "Transport", // Default value for status
            app_status: null, // Default value for app_status
            init_paused: 0, // Default value for init_paused
            cust_app_status: item.cust_app_status || null, // Preserve cust_app_status if exists
            inspection_date: item.inspectionDate || null, // Preserve inspectionDate if exists
          };
        } else {
          // Return the object as-is if it's already in the desired format
          return item;
        }
      });
    }

    // Example usage
    const normalizedInventory = normalizeInventory(combinedInventory);

    // Remove duplicate cars if they exist, excluding objects with .cust_app_status
    const uniqueInventory = normalizedInventory.reduce((acc, car) => {
      // Check if an entry with the same id already exists in the accumulator and does not have cust_app_status
      const existingCarIndex = acc.findIndex(
        (item) => item.id === car.id && !item.cust_app_status
      );

      if (existingCarIndex === -1 || car.cust_app_status) {
        // If no duplicate exists, or the current car has cust_app_status, add it to the accumulator
        acc.push(car);
      }

      return acc;
    }, []);

    setLocationInventory(uniqueInventory);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventory, inspections, customers, userLocations]);

  const fetchData = useCallback(async () => {
    await retrieveLoginLocationId();
    await fetchInspections();
    await fetchInventory();
    await fetchCustomers();
    await fetchSteps();
  }, [apiUrl, loginLocationId, fetchCustomers, fetchInspections, fetchInventory, fetchSteps]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (userRole === 1) {
      setRelevantSteps([7]);
      setRelevantWords(["Sales"]);
    } else if (userRole === 2) {
      setRelevantSteps([
        1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      ]);
      setRelevantWords([
        "Initial_Inspection",
        "key line",
        "init_return",
        "init_repair",
        "Quality Control",
        "Sales",
        "Service",
        "service_repair",
        "Body",
        "body_repair",
        "Recon",
        "Sales Q.C.",
      ]);
    } else if (userRole === 3) {
      setRelevantSteps([1, 9, 11, 12, 13, 14, 15, 16]);
      setRelevantWords([
        "Initial_Inspection",
        "key line",
        "init_return",
        "init_repair",
      ]);
    } else if (userRole === 4) {
      setRelevantSteps([2]);
      setRelevantWords(["Quality Control"]);
    } else if (userRole === 5) {
      setRelevantSteps([3, 17]);
      setRelevantWords(["Service", "service_repair"]);
    } else if (userRole === 6) {
      setRelevantSteps([4, 18]);
      setRelevantWords(["Body", "body_repair"]);
    } else if (userRole === 7) {
      setRelevantSteps([5]);
      setRelevantWords(["Recon"]);
    } else if (userRole === 8) {
      setRelevantSteps([6]);
      setRelevantWords(["Sales Q.C."]);
    }
  }, [userRole]);

  ///DO IMPORTANT THINGS
  useEffect(() => {
    const filteredVehicles = locationInventory.filter((item) => {
      if (relevantSteps.includes(item.app_status || item.cust_app_status)) {
        return true;
      }
      if (!item.app_status && relevantWords.includes(item.status)) {
        return true;
      }
      return false;
    });

    const getLastInspectionDesc = (vehicleId, cust_app_status) => {
      let vehicleInspections;
      if (cust_app_status) {
        vehicleInspections = inspections.filter(
          (inspection) => inspection.custRepairId === vehicleId
        );
      } else {
        vehicleInspections = inspections.filter(
          (inspection) => inspection.inventory_id === vehicleId
        );
      }

      if (vehicleInspections.length > 0) {
        // Sort inspections by date or ID (assuming they are timestamped or ordered in some way)
        const lastInspection =
          vehicleInspections[vehicleInspections.length - 1]; // Last in the array

        return {
          inspection_date: lastInspection.inspection_date,
          description: lastInspection.description,
        };
      }
      return ""; // If no inspection found, return an empty string or placeholder
    };

    // Create the new array by merging fields from filteredVehicles and inspection descriptions
    const withInspDesc = filteredVehicles.map((vehicle) => {
      const inspObj = getLastInspectionDesc(
        vehicle.id,
        vehicle.cust_app_status
      );

      const insp_desc = inspObj.description; // Get the inspection description
      const insp_date = inspObj.inspection_date;
      return {
        ...vehicle, // Spread existing vehicle fields
        insp_date,
        insp_desc, // Add the inspection description field
      };
    });

    // Set vehicles to the new array
    const sortedVehicles = withInspDesc.sort((a, b) => {
      const dateA = a.insp_date ? new Date(a.insp_date) : null;
      const dateB = b.insp_date ? new Date(b.insp_date) : null;

      // Handle cases where insp_date is undefined or null
      if (!dateA && dateB) return 1; // a's date is undefined, put it after b
      if (dateA && !dateB) return -1; // b's date is undefined, put b after a
      if (!dateA && !dateB) return 0; // both dates are undefined, keep the same order

      return dateB - dateA; // Sort by descending date (most recent first)
    });

    // Set vehicles to the sorted array
    setVehicles(sortedVehicles);
  }, [locationInventory, inspections, relevantSteps, relevantWords]);

  // console.log("vehicles", vehicles);
  /////////////

  useEffect(() => {
    const cust_rows = vehicles.filter((veh) => {
      // Your filter logic here, for example:
      return veh.cust_app_status && veh.cust_app_status !== 20;
    });
    setCustomerRows(cust_rows);
    // Optionally, do something with cust_rows here
  }, [vehicles]);

  const translateLocation = (locationCode) => {
    const locationMap = {
      S01_Holmes1: "Diberville",
      S05_Montgomery1: "Montgomery",
      S07_Bham1: "Birmingham",
      S09_Douglas1: "Douglasville",
    };
    return locationMap[locationCode] || "Unknown Location";
  };

  const handleBeginInspection = (vehicle) => {
    const stock = vehicle.stock;
    setStock(stock);
    setIsModalOpen(true);
  };

  //   console.log("inspectionTypes", inspectionTypes);
  // console.log("customerRows IncTableAd", customerRows);

  const formatDescription = (description) => {
    if (!description) return "No description";

    const [beforeComma, ...afterComma] = description.split(","); // Split by the first comma

    // Combine the first part (beforeComma) with any remaining parts (afterComma) as a plain string
    return `${beforeComma}${
      afterComma.length > 0 ? `,${afterComma.join(",")}` : ""
    }`;
  };

  const mapSectionFilters = (inspectionTypes) => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: ".5rem" }}>
        {inspectionTypes.map((type, index) => {
          const stepCount =
            stepVehicleCounts.find((step) => step.stepName === type)?.count ||
            0;

          return (
            <div key={type} style={{ display: "flex", gap: ".2rem" }}>
              <Checkbox
                key={index}
                onChange={(event) => {
                  const { checked } = event.target;
                  setSelectedInspectionTypes((prevSelected) => {
                    if (checked) {
                      return [...prevSelected, type];
                    } else {
                      return prevSelected.filter((t) => t !== type);
                    }
                  });
                }}
                checked={selectedInspectionTypes.includes(type)}
              >
                {type}
              </Checkbox>
              <span
                style={{
                  // transform: "translateY(.15rem) translateX(-.4rem)",
                  opacity: ".5",
                }}
              >
                [{stepCount}]
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const handleRepairsOnly = () => {
    setRepairsOnly((prev) => !prev);
  };

  const handleStartNewRepair = () => {
    setStock(null);
    setIsModalOpen(true);
  };

  // Define the columns for the StatefulDataTable
  const columns = [
    StringColumn({
      title: "Vehicle",
      mapDataToValue: (vehicle) =>
        `Stock: ${vehicle.stock} | ${vehicle.year} ${vehicle.make} ${vehicle.model} (${vehicle.color})`,
      sortable: false,
    }),
    StringColumn({
      title: "Location",
      mapDataToValue: (vehicle) => translateLocation(vehicle.location),
    }),
    StringColumn({
      title: "Current Status",
      mapDataToValue: (vehicle) => {
        // Find the step with an id that matches vehicle.app_status
        const matchingStep = steps.find(
          (step) => step.id === (vehicle.app_status || vehicle.cust_app_status)
        );

        // Return the label if a match is found, otherwise return 'Unknown Step'
        return matchingStep ? matchingStep.step_name : "Unknown Step";
      },
    }),
    StringColumn({
      title: "Submitted on",
      mapDataToValue: (vehicle) => formatDate(vehicle.insp_date),
      maxWidth: 190,
      textWrap: "wrap",
      lineClamp: 15,
      fillWidth: false,
    }),
    StringColumn({
      key: "insp_desc",
      title: "Last Inspection Description",
      mapDataToValue: (vehicle) => formatDescription(vehicle.insp_desc),
      maxWidth: 300,
      textWrap: "wrap",
      lineClamp: 15,
      fillWidth: true,

      sortable: false,
    }),
    StringColumn({
      title: "Paused Status",
      mapDataToValue: (vehicle) => {
        // Return "Paused Init Inspection" if init_paused is 1, otherwise return an empty string
        return vehicle.init_paused === 1
          ? "Paused Init Inspection"
          : vehicle.app_status === 15
          ? "RETURNED INIT"
          : "";
      },
    }),
    CustomColumn({
      title: "",
      mapDataToValue: (vehicle) => vehicle,
      renderCell: ({ value }) => {
        const vehicle = value; // Extract the actual vehicle object from 'value'
        // console.log("vehicle", vehicle);
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically (optional)
              height: "100%", // Ensure the button is vertically centered if needed
            }}
          >
            <Button
              size="compact"
              style={{
                //       backgroundColor:
                //         vehicle.init_paused === 1
                //           ? "#ffab70" //light orange
                //           : vehicle.app_status === 15
                //           ? "red"
                //           : vehicle.cust_app_status
                //           ? vehicle.cust_app_status === 21
                //             ? "grey"
                //             : "orange"
                //           : "#b6e5a5", //tope/green
                backgroundColor:
                  vehicle.init_paused === 1
                    ? "#ffab70" // light orange
                    : vehicle.app_status === 15
                    ? "red"
                    : vehicle.cust_app_status
                    ? vehicle.cust_app_status === 20
                      ? "grey" // grey if cust_app_status is 21
                      : "orange"
                    : "#b6e5a5", // taupe/green
                color:
                  vehicle.init_paused !== 1
                    ? vehicle.app_status !== 15
                      ? !vehicle.cust_app_status
                        ? "black"
                        : vehicle.cust_app_status === 20
                        ? "white" // grey if cust_app_status is 21
                        : "black"
                      : ""
                    : "black",
                width: "150px",
                textAlign: "center",
              }}
              onClick={(event) => {
                event.stopPropagation();
                handleBeginInspection(vehicle);
              }}
            >
              {vehicle.init_paused === 1
                ? vehicle.app_status === 11
                  ? "Resume Roadtest"
                  : vehicle.app_status === 12
                  ? "Resume Exterior"
                  : vehicle.app_status === 13
                  ? "Resume Underhood"
                  : vehicle.app_status === 14
                  ? "Resume Interior"
                  : "Begin Inspection (Init Transfer)"
                : vehicle.app_status === 15
                ? "View Returned Init"
                : vehicle.app_status === null && vehicle.cust_app_status !== null
                ? vehicle.cust_app_status === 19
                  ? "View Completed Repair"
                  : vehicle.cust_app_status === 20
                  ? "Closed Repair" // grey if cust_app_status is 21
                  : "Begin Repair"
                : vehicle.app_status === 11
                ? "Begin Roadtest"
                : vehicle.app_status === 12
                ? "Begin Exterior"
                : vehicle.app_status === 13
                ? "Begin Underhood"
                : vehicle.app_status === 14
                ? "Begin Interior"
                : vehicle.app_status === 1
                ? "Begin Roadtest"
                : "Begin Inspection"}
            </Button>
          </div>
        );
      },
    }),
  ];

  return (
    <div
      style={{
        border: "2px solid darkGrey",
        // height: "maxContent",
        padding: "1rem",
        boxShadow: "inset 0px 8px 50px 15px rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
      }}
    >
      <h1>
        Open Jobs
        <span style={{ fontSize: "1.25rem", fontWeight: 300 }}>
          {" "}
          in {locationLabel} [
          {filteredVehicles.length > 0
            ? filteredVehicles.length
            : selectedInspectionTypes.length > 0
            ? filteredVehicles.length
            : repairsOnly
            ? customerRows.length
            : vehicles.length}
          ]
        </span>
      </h1>
      <Button
        style={{
          border: "2px solid darkGrey",
          color: "black",
          fontWeight: 400,
          backgroundColor: "#d3edf1",
          padding: ".5rem",
          marginBottom: "1rem",
        }}
        // onMouseEnter={() => setIsHovered(true)}
        // onMouseLeave={() => setIsHovered(false)}
        onClick={() => fetchData()}
      >
        Refresh Jobs
      </Button>

      <Button
        onClick={handleRepairsOnly}
        overrides={{
          BaseButton: {
            style: ({ $theme }) => ({
              backgroundColor: repairsOnly ? "orange" : "	#ffe2b9", // Light blue background
              color: "black", // Adjust text color if needed
              ":hover": {
                color: "white", // Text color on hover
              },
              fontSize: "14px", // Smaller font size
              paddingTop: "6px",
              paddingBottom: "6px",
              paddingLeft: "12px",
              paddingRight: "12px",
              marginLeft: "1rem",
            }),
          },
        }}
      >
        ACTIVE REPAIRS ONLY
      </Button>

      <Button
        //         onClick={handleRepairsOnly}
        onClick={handleStartNewRepair}
        overrides={{
          BaseButton: {
            style: ({ $theme }) => ({
              backgroundColor: "lightGreen", // Light blue background
              color: "black", // Adjust text color if needed
              ":hover": {
                backgroundColor: "darkGreen",
                color: "white", // Text color on hover
              },
              fontSize: "14px", // Smaller font size
              paddingTop: "6px",
              paddingBottom: "6px",
              paddingLeft: "12px",
              paddingRight: "12px",
              marginLeft: "1rem",
            }),
          },
        }}
      >
        CREATE NEW REPAIR
      </Button>

      {mapSectionFilters(Object.values(stepsMap))}
      <div
        style={{
          height: "44vh",
          marginBottom: "1rem",
        }}
      >
        <StatefulDataTable
          // key={vehicles.length}
          searchable={true}
          includeSearch
          columns={columns}
          // rows={vehicles.map((vehicle) => ({ id: vehicle.id, data: vehicle }))}
          rows={
            selectedInspectionTypes.length > 0
              ? filteredVehicles.map((vehicle) => ({
                  id: vehicle.id,
                  data: vehicle,
                }))
              : repairsOnly
              ? customerRows.map((vehicle) => ({
                  id: vehicle.id,
                  data: vehicle,
                }))
              : vehicles.map((vehicle) => ({ id: vehicle.id, data: vehicle }))
          }
          rowHeight={68}
        />

        <Modal
          onClose={() => {
            setIsModalOpen(false);
          }}
          closeOnEsc={false}
          closeOnBackdropClick={false}
          isOpen={isModalOpen}
          size={SIZE.auto}
        >
          <ModalBody>
            <VehicleUpdateForm
              stockNum={stock}
              setIsModalOpen={setIsModalOpen}
              isModalOpen={isModalOpen}
            />
            {/* <h3>{inspectionObject.</h3> */}
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default IncomingTable;
